module.exports = __webpack_public_path__ + "static/media/crash.8966122a.png";